import { baseRxnDmg, NAs } from "../configs";
import { bareLv, pickOne, turnArr } from "../helpers";

export function getRxnBnesFromEM(EM = 0) {
  return {
    transformative: Math.round((16000 * EM) / (EM + 2000)) / 10,
    amplifying: Math.round((2780 * EM) / (EM + 1400)) / 10,
    shield: Math.round((4440 * EM) / (EM + 1400)) / 10
  };
}

export function getQuickenBuffDamage(char, EM, rxnBnes) {
  const base = baseRxnDmg[bareLv(char.level)];
  const bonus = 1 + (5 * EM) / (EM + 1200);
  return {
    aggravate: Math.round(base * 1.15 * (bonus + rxnBnes.aggravate / 100)),
    spread: Math.round(base * 1.25 * (bonus + rxnBnes.spread / 100))
  };
}

export function getDefMult(charLv, targetLv, rdMult, attPatt) {
  const charPart = bareLv(charLv) + 100;
  const defRd = 1 - rdMult.Def_rd / 100;
  let defIg = 1;
  if (attPatt && rdMult[`${attPatt}_ig`]) {
    defIg = 1 - rdMult[`${attPatt}_ig`] / 100;
  }
  return charPart / (defRd * defIg * (targetLv + 100) + charPart);
}

export const getResMult = (target, rdMult, key) => {
  const RES = (target[`${key} RES`] - (rdMult[`${key}_rd`] || 0)) / 100;
  return RES < 0 ? 1 - RES / 2 : RES >= 0.75 ? 1 / (4 * RES + 1) : 1 - RES;
};

export const calcDmg = (base, formula) =>
  Array.isArray(base) ? base.map((b) => formula(b)) : formula(base);

export function dmgFormula(
  totalFlat,
  normalMult,
  specialMult,
  rxnMult,
  defMult,
  resMult
) {
  return (n) =>
    (n + totalFlat) * normalMult * specialMult * rxnMult * defMult * resMult;
}

export function pushOrMerge(obj, field, desc, value) {
  if (obj) {
    const existed = obj[field].find((note) => note.desc === desc);
    if (existed) {
      existed.value += value;
    } else {
      obj[field].push({ desc, value });
    }
  }
}

export const pickTlBn = (tlBnes, field) => tlBnes[field]?.value || 0;

// ----- //

export function addAndTrack(desc, target, paths, rootValue, tracker) {
  turnArr(paths).forEach((path, i) => {
    const routes = path.split(".");
    const value = pickOne(rootValue, i);
    const node = { desc, value };
    if (routes.length === 1) {
      target[routes[0]] += value;
      if (tracker) {
        tracker[routes[0]].push(node);
      }
    } else {
      target[routes[0]][routes[1]] += value;
      if (tracker) {
        tracker[routes[0]][routes[1]].push(node);
      }
    }
  });
}

export const simpleAnTmaker = (target, paths, rootValue) => (args) => {
  if (args[target]) {
    const { tkDesc, tracker } = args;
    addAndTrack(tkDesc, args[target], paths, rootValue, tracker);
  }
};

export function incElementalBnes(settings, hitBnes, desc, tracker) {
  const { elmt, type, value } = settings;
  if (settings.vision === elmt) {
    addAndTrack(desc, hitBnes, `Elemental.${type}`, value, tracker);
  }
  for (const naType of NAs) {
    if (settings.infusion[naType] === elmt) {
      addAndTrack(desc, hitBnes, `${naType}.${type}`, value, tracker);
    }
  }
}
